import { ArrowUpRight } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { API_DOCS_URL } from '../../../config/features';

const SNIPPET = `curl -X POST https://api.cmsh.io/v1/links \\
  -H "Authorization: Bearer ck_live_…" \\
  -H "Content-Type: application/json" \\
  -d '{ "originalUrl": "https://example.com/launch", "customAlias": "launch" }'

# → { "shortUrl": "https://cmsh.io/launch", "shortCode": "launch", ... }`;

export function ApiSection() {
  return (
    <section id="api" className="scroll-mt-20 bg-bg-deep">
      <div className="mx-auto grid max-w-[1240px] items-center gap-10 px-5 py-12 sm:px-8 sm:py-16 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16">
        <div>
          <p className="text-[13px] font-semibold uppercase tracking-[0.08em] text-link">Developer API</p>
          <h2 className="mt-3 text-[32px] font-bold leading-tight tracking-tight text-text sm:text-[44px]">
            One request. One short link.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-text-2">
            Create, update and inspect links from your own stack. Keyed access, per-plan rate limits and the same
            analytics you see in the dashboard.
          </p>
          <Button
            variant="secondary"
            className="mt-8"
            rightIcon={<ArrowUpRight className="size-4" aria-hidden />}
            onClick={() => window.open(API_DOCS_URL, '_blank', 'noopener,noreferrer')}
          >
            Read the docs
          </Button>
        </div>

        <figure className="min-w-0 overflow-hidden rounded-card border border-border bg-surface shadow-card">
          <figcaption className="flex items-center gap-2 border-b border-border px-4 py-3 text-xs text-muted">
            <span className="size-2.5 rounded-full bg-danger/70" aria-hidden />
            <span className="size-2.5 rounded-full bg-warning/70" aria-hidden />
            <span className="size-2.5 rounded-full bg-success/70" aria-hidden />
            <span className="ml-2 font-mono">POST /v1/links</span>
          </figcaption>
          <pre tabIndex={0} className="overflow-x-auto p-5 font-mono text-[13px] leading-relaxed text-text-2 sm:text-sm">
            <code>{SNIPPET}</code>
          </pre>
        </figure>
      </div>
    </section>
  );
}
